import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import logisticsApi from '@utils/logisticsApi';
import { useI18n } from '@/i18n';
import PageHeader from '@components/PageHeader';
import { IconBox } from '@components/icons';

export default function MyAssets() {
  const { t, lang } = useI18n();
  const [assets,  setAssets]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  const load = () => {
    setLoadError(false);
    logisticsApi.get('/me/assets')
      .then(({ data }) => setAssets(data.assets || []))
      .catch(() => setLoadError(true))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <>
      <PageHeader title={t('logisticsAssets.title')} subtitle={t('logisticsAssets.subtitle')} />
      <div className="px-5 md:px-0 pb-6">
        {loading ? (
          <div className="card p-8 text-center text-gray-400">{t('common.loading')}</div>
        ) : loadError ? (
          <div className="card p-10 text-center">
            <p className="text-sm text-red-600 mb-3">{t('logisticsAssets.errLoad')}</p>
            <button onClick={load} className="btn-ghost text-xs">{t('logisticsAssets.retry')}</button>
          </div>
        ) : assets.length === 0 ? (
          <div className="card p-10 text-center">
            <div className="mx-auto w-12 h-12 grid place-items-center rounded-xl bg-gray-100 text-gray-400 mb-3">
              <IconBox size={24} />
            </div>
            <p className="text-sm text-gray-500">{t('logisticsAssets.empty')}</p>
          </div>
        ) : (
          <div className="space-y-2.5">
            {assets.map((a, i) => (
              <motion.div key={a.id ?? i}
                initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: i * 0.04 }}
                className="card p-4 flex items-center gap-4">
                <span className="shrink-0 grid place-items-center w-10 h-10 rounded-xl bg-glk-blue/10 text-glk-blue">
                  <IconBox size={20} />
                </span>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-glk-dark truncate">{t(`logisticsAssets.category.${a.category}`) || a.category} · {a.asset_tag}</p>
                  <p className="text-xs text-gray-400 truncate">
                    {a.started_at && new Date(a.started_at).toLocaleDateString(lang === 'en' ? 'en-GB' : 'pt-PT')}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
